import * as $ from 'jquery';
import 'bootstrap';
import {bookingFormCommon} from './c005-bookingform-common';
import { wcagOptions } from "./wcag";

export class flightSheduleForms{
	private wcag = new wcagOptions();
	private $viewBookingError:Array<string> = [];
	private bcommon = new bookingFormCommon();

	$scope: any = $('#view-booking--container');
    $scopeMob: any = $('#mob-viewbooking--container');

    /**
	 * @function initSelectize
	 * @param  {any} listItems [description]
	 * @return {any}           [description]
	 * !!! Properly scoped
	 */
    initSelectize(listItems: any): void {
        let _self = this;
        let $fhToLocationContainer: any = $('.flight-shedule--widget');
        let $fhDepDateContainer: any = $('#depDate');
        let $fhFromLocation: any = $('.from--location');
        let $fhFromSelectize: any;
        let $fromLocationSelectizeInput:any = $fhFromLocation.parent().find('.selectize-control .selectize-input');
        let $fhToLocation: any = $('.to--location');
        let $fhToSelectize: any;
        $('.miles-table').hide();
        $fhFromLocation.html(listItems);
        $fhFromLocation.selectize({
            onInitialize: function () {
                $fhFromSelectize = $($fhFromLocation[0].selectize.$control[0]);
            },
            onFocus: function () {
                $fromLocationSelectizeInput.removeClass('has-error');
                
            },
            onChange: function (value: any) {
                if ($fhFromLocation.val() != '') {
                    $fhFromLocation.find('input[type="select-one"]').focus();
                    $fhFromLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
                }
                _self.bcommon.updateAirportOnDListOnFlowChangeNew("flightstatus", $fhFromLocation.val().trim(), $fhToLocation);
                },
            onBlur: function (data: any) {
            },
            onLoad: function (data: any) {
            },
			lockOptgroupOrder: true,
			searchField: ['text'],
			selectOnTab: true,
			render: {
				item: function (item: any, escape: any) {
					return '<div>' +
						(item.text ? '<span class = "airportname airportselected">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>' : '') +
						'</div>';

				},
				option: function (item: any, escape: any) {
                    let pOpen:any = '';
                    let pClose:any ='';
                    let ptag:any ='';
                    let coma:any =',';
                    if(screen.width < 768){
                        pOpen = '<p class = "airportline">';
                       pClose ='</p>';
                       ptag ='<p>';
                       coma ='';
                    }
					return '<div>' +
						(item.text ? pOpen+'<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) +coma+ '</span>' +
							'<span class = "airportcode">' +
							escape(item.text.split('|')[2]) + '</span>'+pClose+ptag + escape(item.text.split('|')[1]) +  pClose: '') +
						'</div>';
				}
			}
		});
        $fhFromLocation.html(listItems);
        $('#preferredCity.from--location').data('selectize').setValue("KUL");
        $fhToLocation.html(listItems);
        $fhToLocation.selectize({
            onInitialize: function () {
                $fhToSelectize = $($fhToLocation[0].selectize.$control[0]);
            },
            onFocus: function () {

            },
            onChange: function (value: any) {
                if ($fhToLocation.val() != '') {
                    
                   // $fhToLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
                }
            },
            onBlur: function (data: any) {
            },
            onLoad: function (data: any) {
            },
			lockOptgroupOrder: true,
			searchField: ['text'],
			selectOnTab: true,
			render: {
				item: function (item: any, escape: any) {
					return '<div>' +
						(item.text ? '<span class = "airportname airportselected">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>' : '') +
						'</div>';

				},
				option: function (item: any, escape: any) {
                    let pOpen:any = '';
                    let pClose:any ='';
                    let ptag:any ='';
                    let coma:any =',';
                    if(screen.width < 768){
                        pOpen = '<p class = "airportline">';
                       pClose ='</p>';
                       ptag ='<p>';
                       coma ='';
                    }
					return '<div>' +
						(item.text ? pOpen+'<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) +coma+ '</span>' +
							'<span class = "airportcode">' +
							escape(item.text.split('|')[2]) + '</span>'+pClose+ptag + escape(item.text.split('|')[1]) +  pClose: '') +
						'</div>';
				}
			}
		});

        $(".from--location").keydown(function (event: any) {
            if (event.keyCode === 9) {
                event.preventDefault();
                event.stopPropagation();
            }
        });
    }
	formValidation($instance:any, callback:any):any {
		let _self = this;
		let $errorList:Array<string> = [];

		let $errorValidation = $instance.find('.miles-error-validation').first();
		let formDataValid = true;

		let $fromLocation:any     = $instance.find('.from--location'),
			$fromBookingTitle:any = $fromLocation.parent().find('.booking-form--title'),
			$fromSelectize:any    = $fromLocation.parent().find('.selectize-control .selectize-input');

		let $passengerDetailsActive:any = $('[data-booking-passenger-details-selected]');

		// Validation: IBE From Location empty field
		if ($fromLocation.val() == '') {
			$fromSelectize.addClass('has-error');
			$fromBookingTitle.addClass('has-error');
			let $fromLocValidate:any = $fromLocation.attr('data-from-error');
			$errorList.push('<strong>'+$fromLocation.parent().text()+':</strong> '+$fromLocValidate);
			formDataValid = false;
		} else {
			$fromSelectize.removeClass('has-error');
			$fromBookingTitle.removeClass('has-error');
		}

		let $toLocation:any     = $instance.find('.to--location'),
			$toBookingTitle:any = $toLocation.parent().find('.booking-form--title'),
			$toSelectize:any    = $toLocation.parent().find('.selectize-control .selectize-input');

		// Validation: IBE To Location empty field
		if ($toLocation.val() == '') {
			$toSelectize.addClass('has-error');
			$toBookingTitle.addClass('has-error');

			let $toLocValidate:any = $toLocation.attr('data-to-error');
			$errorList.push('<strong>'+$toLocation.parent().text()+':</strong> '+$toLocValidate);
			formDataValid = false;
		} else {
			$toSelectize.removeClass('has-error');
			$toBookingTitle.removeClass('has-error');
		}

		// Validation: IBE From/To Location identical value
		if ($fromLocation.val() === $toLocation.val()) {
			$toSelectize.addClass('has-error');
			$toBookingTitle.addClass('has-error');
			formDataValid = false;

			if (!($fromLocation.val() == '' || $toLocation.val() == '')){
				let $fromLoLocValidate:any = $fromLocation.attr('data-from-to-error');
				 $errorList.push($fromLoLocValidate);
			}
		}

		let $validationContainer:any = $errorValidation.find(".validation-content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist:any = $validationContainer;

		for (var i=0, len=$errorList.length; i<len; i++) {
			$validationMessagelist.append('<li data-id="'+i+'">' + $errorList[i] + '</li>');
		}

		if (formDataValid) {
			// proceed to retrieve input vars (callback fn)
			if (typeof callback === "function") {
				callback();
			}
		} else {
			return false;
		}
	}
	getRevenuewOND(): void {
        let _self = this;
        let $instance: any = $('.flight-shedule--widget');
        let $fromLocation:any     = $instance.find('.from--location').val();
		let $toLocation:any     = $instance.find('.to--location').val();
        if(window.location.hostname == "localhost" && window.location.port == "5000"){
       let response:any = {"flightSheduledResult":[
           {"depertureTime":"13:55","arrivalTime":"14:50","dateOfDeperture":"19-Jun-20"},
           {"depertureTime":"15:50","arrivalTime":"16:55","dateOfDeperture":"19-Jun-20"},
           {"depertureTime":"13:55","arrivalTime":"14:50","dateOfDeperture":"20-Jun-20"},
           {"depertureTime":"15:50","arrivalTime":"16:55","dateOfDeperture":"20-Jun-20"},
           {"depertureTime":"13:55","arrivalTime":"14:50","dateOfDeperture":"21-Jun-20"}
            ]
           }
        
            _self.displayFlightShedule(response);
        }else{
            $.ajax({
                type: 'GET',
                url: '/bin/services/new/flightscheduleresult?leg='+$fromLocation+$toLocation,
                success: function(json:any) {
                    json = JSON.parse(json);
                    _self.displayFlightShedule(json);
                },
                error: function(error:any) {
                    console.log("Error while getting member info", error);
                }
            });		
        }	
    }

    /* Display earnrich miles table */
	displayFlightShedule(response:any): void {
		let _self = this;
        let $milesHtlml: any;
        var responselist =response.flightSheduledResult;
        if(responselist.length == 0){
           $milesHtlml +=   '<tr>'
           +'<td align= "center" colspan="3">There are currently no flights scheduled for your requested route. </td>'
           + '</tr>';
        }else{
            for (var k in responselist) {
                $milesHtlml +=   '<tr>' 
                +'<td class="month-1">'+responselist[k].dateOfDeperture+'</td>'
                + '<td class="month-2">'+responselist[k].depertureTime+'</td>'
                + '<td class="month-3">'+responselist[k].arrivalTime+'</td>'
                + '</tr>';
              }
 
        }  
        $('.miles-data-display').html($milesHtlml); 
        if(responselist.length >10){
            $('.load-more-shedule').show();
        }

        $('.miles-data-display').find('tr').slice(0,10).show();
        $('.miles-table').show();
	}

    /**
	 * @function searchHandler
	 * !!! Properly scoped
	 */
	searchHandler(): void {
		let _self = this;

        let $submitBtn:any    = $('.flight-shedule-btn');
        let $locationContainer: any = $('.flight-shedule--widget');
        let $errorValidation = $('.miles-error-validation').first();
        $('.miles-table').hide();
			$submitBtn.on('click', (evt:any) => {
                $errorValidation.show();
				_self.formValidation($locationContainer, function(){
                    _self.getRevenuewOND();
                });
              //  _self.formValidation($locationContainer);

			});
	}


}
$('.load-more-shedule').on('click', (evt:any) => {
    $('.miles-data-display').find('tr:hidden').slice(0,10).slideDown();
    if ($('.miles-data-display').find('tr:hidden').length == 0) {
        $(".load-more-shedule").fadeOut('slow');
    }

});

let scope:Element = document.querySelector('.flight-shedule--widget');
if (scope){
	try {
        let flightSheduleForm = new flightSheduleForms();
        let bookingformcommon = new bookingFormCommon();
		$.when(window['ibeOnDListNew']).done((listData: any) => {
        let listItems:string = bookingformcommon.parseOnDListItemsNew(listData, 'redemption', 'flightstatus');
        flightSheduleForm.initSelectize(listItems);
        });
        flightSheduleForm.searchHandler();

	} catch(e) {console.error(e);}
}